import $ from 'jquery';
var uni;

window.addEventListener('load', function() {

  const mobileFilters = $('.js-filters');

  if (mobileFilters.length) {
    const mobileFiltersItem = $('.js-filters-item');
    const mobileFiltersToggle = $('.js-filters-toggle');
    const mobileFiltersContent = $('.js-filters-content');

    mobileFiltersToggle.click(function() {
      mobileFiltersContent.slideToggle(250);
      mobileFiltersItem.toggleClass('is-active');
    });
  }

  // Hide Taxonomy Title & Terms if There is no any displayed Term
  $('.gamme__filters__checkbox-filters .js-accordion .accordion-item').each(function() {
    if( $(this).find('.facetwp-facet .facetwp-checkbox').length ){
      $(this).removeClass('visually-hidden');
    }
  });

  // Scroll to Page content after 'All' filter link in (Sous-)Gamme Page
  var hash = window.location.hash;
  if(hash == '#all'){
    var offset = $('.gamme__container').offset().top - 70;

    if($('.admin-bar').length > 0)
      offset = offset - 32;

    $('html, body').animate( { scrollTop: offset }, 400 );
  }

  /**
   * One-Team page
   */
  manageRidersSubfilters();
  $(document).on('facetwp-loaded', function() {
    manageRidersSubfilters();
  });

});

/**
 * Get URL Parameters - From Get Method Form
 */
function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
  var results = regex.exec(url);
  if (!results || !results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

// Display selected Universe Specialties in Riders filters
function manageRidersSubfilters(){

  // Get current universe
  uni = getParameterByName('_uni');

  // Show "Specialite" filters only if one "Univers" is selected
  if(uni)
    $('.document-list__subfilters').removeClass('hidden');

  // Hide all subfilters by default
  $('.document-list__subfilters').addClass('hidden');
  $('.document-list__subfilters .facetwp-radio').addClass('hidden');

  // Display subfilters according to main filter
  switch (uni) {
  case "all":
    break;
  case "kite":
    $('.document-list__subfilters').removeClass('hidden');
    $('.document-list__subfilters .facetwp-radio[data-value="freestyle"]').removeClass('hidden');
    $('.document-list__subfilters .facetwp-radio[data-value="freestyle-fr"]').removeClass('hidden');
    $('.document-list__subfilters .facetwp-radio[data-value="foil"]').removeClass('hidden');
    $('.document-list__subfilters .facetwp-radio[data-value="foil-fr"]').removeClass('hidden');
    $('.document-list__subfilters .facetwp-radio[data-value="strapless"]').removeClass('hidden');
    $('.document-list__subfilters .facetwp-radio[data-value="strapless-fr"]').removeClass('hidden');
    $('.document-list__subfilters .facetwp-radio[data-value="snow-kite"]').removeClass('hidden');
    $('.document-list__subfilters .facetwp-radio[data-value="snow-kite-fr"]').removeClass('hidden');
    $('.document-list__subfilters .facetwp-radio[data-value="race"]').removeClass('hidden');
    $('.document-list__subfilters .facetwp-radio[data-value="race-fr"]').removeClass('hidden');
    $('.document-list__subfilters .facetwp-radio[data-value="waves"]').removeClass('hidden');
    $('.document-list__subfilters .facetwp-radio[data-value="waves-fr"]').removeClass('hidden');
    break;
  case "stand-up-paddle":
    $('.document-list__subfilters').removeClass('hidden');
    $('.document-list__subfilters .facetwp-radio[data-value="sup-foil"]').removeClass('hidden');
    $('.document-list__subfilters .facetwp-radio[data-value="sup-foil-fr"]').removeClass('hidden');
    $('.document-list__subfilters .facetwp-radio[data-value="race"]').removeClass('hidden');
    $('.document-list__subfilters .facetwp-radio[data-value="race-fr"]').removeClass('hidden');
    $('.document-list__subfilters .facetwp-radio[data-value="waves"]').removeClass('hidden');
    $('.document-list__subfilters .facetwp-radio[data-value="waves-fr"]').removeClass('hidden');
    break;
  }
}
